import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import { getPicklist } from '../actions';

class PersonalDetails extends React.Component {
    shouldComponentUpdate() {
        return true;
    }

    render() {
        const {
            form, errorMessage, onInputChanged, objectInfo,
        } = this.props;
        return (
            <div className="row">
                <br />
                <h4 className="info-text">Personal Details</h4>
                <br />
                <div className="col-sm-6">
                    <div className="form-group">
                        <label>Full Name in NRIC <small style={{ color: 'red' }}>(required)</small></label>
                        <input
                            name="Full_Name__c"
                            id="Full_Name__c"
                            type="text"
                            className={`form-control ${errorMessage.Full_Name__c ? 'need-fix' : ''}`}
                            value={form.Full_Name__c}
                            onChange={onInputChanged}
                        />
                        <p className="error-message">{errorMessage.Full_Name__c}</p>
                    </div>
                    
                    <div className="form-group">
                        <label>Date of Birth <small className="red">(required)</small></label>
                        <DatePicker
                            name="Date_of_Birth__c"
                            selected={moment(form.Date_of_Birth__c)}
                            dateFormat="DD/MM/YYYY"
                            onChange={val => onInputChanged(val, 'Date_of_Birth__c')}
                            className={`form-control ${errorMessage.Date_of_Birth__c ? 'need-fix' : ''} fullwd`}
                            maxDate={moment()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                        />
                        <p className="error-message">{errorMessage.Date_of_Birth__c}</p>
                    </div>
                    <div className="form-group">
                        <label>Marital Status <small className="red">(required)</small></label>
                        <select
                            name="Marital_Status__c"
                            id="Marital_Status__c"
                            onChange={onInputChanged}
                            value={form.Marital_Status__c}
                            required
                            className={`form-control ${errorMessage.Marital_Status__c ? 'need-fix' : ''}`}
                        >
                            <option value="" />
                            {getPicklist('Marital_Status__c', objectInfo.Person__c,)}
                        </select>
                        <p className="error-message">{errorMessage.Marital_Status__c}</p>
                    </div>
                    <div className="form-group">
                        <label>Other Marital Status</label>
                        <input
                            name="Other_Marital_Status__c"
                            type="text"
                            value={form.Other_Marital_Status__c}
                            onChange={onInputChanged}
                            className={`form-control ${errorMessage.Other_Marital_Status__c ? 'need-fix' : ''}`}
                            disabled={form.Marital_Status__c !== 'Others'}
                        />
                        <p className="error-message">{errorMessage.Other_Marital_Status__c}</p>
                    </div>

                </div>
                <div className="col-sm-6">
                    <div className="form-group">
                        <label>Nationality <small className="red">(required)</small></label>
                        <select
                            name="Nationality__c"
                            onChange={e => onInputChanged(e.target.value, 'Nationality__c')}
                            value={form.Nationality__c}
                            className={`form-control valid select ${errorMessage.Nationality__c ? 'need-fix' : ''}`}
                            required
                        >
                            <option value="" />
                            {getPicklist('Nationality__c', objectInfo.Person__c)}
                        </select>
                        <p className="error-message">{errorMessage.Nationality__c}</p>
                    </div>
                    <div className="form-group" >
                        <label>Other Nationality</label>
                        <input
                            name="Other_Nationality__c"
                            type="text"
                            className={`form-control valid select ${errorMessage.Other_Nationality__c ? 'need-fix' : ''}`}
                            value={form.Other_Nationality__c || ''}
                            onChange={onInputChanged}
                            disabled={form.Nationality__c !== 'Others'}
                        />
                        <p className="error-message">{errorMessage.Other_Nationality__c}</p>
                    </div>
                    <div className="form-group">
                        <label>ID Type <small className="red">(required)</small></label>
                        <select
                            id="ID_Type__c"
                            name="ID_Type__c"
                            className={`form-control ${errorMessage.ID_Type__c ? 'need-fix' : ''}`}
                            aria-invalid="false"
                            value={form.ID_Type__c}
                            onChange={onInputChanged}
                        >
                            <option value="" />
                            {
                                getPicklist('ID_Type__c', objectInfo.Person__c)
                            }
                        </select>
                        <p className="error-message">{errorMessage.ID_Type__c}</p>
                    </div>
                    <div className="form-group">
                        <label>ID Number <small style={{ color: 'red' }}>(required)</small></label>
                        <input
                            name="ID_Number__c"
                            id="ID_Number__c"
                            type="text"
                            className={`form-control ${errorMessage.ID_Number__c ? 'need-fix' : ''}`}
                            value={form.ID_Number__c}
                            maxLength={form.ID_Type__c === 'Others' ? 32 : 9}
                            onChange={onInputChanged}
                            placeholder="NRIC e.g. S9268776G"
                        />
                        <p className="error-message">{errorMessage.ID_Number__c}</p>
                    </div>
                    
                    {/* <div className="form-group">
                        <label>Gender <small className="red">(required)</small></label>
                        <select
                            name="Gender__c"
                            id="Gender__c"
                            className={`form-control valid select ${errorMessage.Gender__c ? 'need-fix' : ''}`}
                            aria-invalid="false"
                            onChange={onInputChanged}
                            value={form.Gender__c}
                        >
                            <option value="" />
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                        </select>
                        <p className="error-message">{errorMessage.Gender__c}</p>
                    </div> */}
                    {/* <div className="form-group">
                        <label>Race <small className="red">(required)</small></label>
                        <select
                            id="Race__c"
                            name="Race__c"
                            className={`form-control valid select ${errorMessage.Race__c ? 'need-fix' : ''}`}
                            aria-invalid="false"
                            onChange={onInputChanged}
                            value={form.Race__c || ''}
                        >
                            <option value="" className="white" />
                            {getPicklist('Race__c', objectInfo.Person__c)}
                        </select>
                        <p className="error-message">{errorMessage.Race__c}</p>
                    </div>
                    <div className="form-group">
                        <label>Other Race</label>
                        <input
                            name="Other_Race__c"
                            type="text"
                            className={`form-control valid select ${errorMessage.Other_Race__c ? 'need-fix' : ''}`}
                            value={form.Other_Race__c || ''}
                            onChange={onInputChanged}
                            disabled={form.Race__c !== 'Others'}
                        />
                        <p className="error-message">{errorMessage.Other_Race__c}</p>
                    </div> */}
                </div>
            </div>
        );
    }
}

PersonalDetails.propTypes = {
    form: PropTypes.object.isRequired,
    onInputChanged: PropTypes.func.isRequired,
    objectInfo: PropTypes.object.isRequired,
    errorMessage: PropTypes.object.isRequired,
};

export default PersonalDetails;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/Tab2/PersonalDetails.js
// module id = 1013
// module chunks = 0